import { generatePath, useNavigate } from 'react-router-dom';
import { IconSettings } from '@ui/src';
import { useAppDispatch } from '@store';
import { onUserChange } from '../../../hoc/user-list/store/slices/users';
import { UserStatuses } from '../../../hoc/user-list/types';
import { ColumnRowUsersTypes } from './types';

import ROUTES from '../../../routes';

import cn from './styles.module.css';

const ColumnRowUsers = ({
  user,
  isSelectedRow,
}: ColumnRowUsersTypes): React.JSX.Element => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return (
    <div
      className={`${cn.columnRow} ${isSelectedRow ? cn.columnRowActive : ''}`}
    >
      <button
        onClick={() => {
          dispatch(onUserChange(user.id));
        }}
        className={`${cn.columnRowLink} ${
          isSelectedRow ? cn.columnRowLinkActive : ''
        }`}
        aria-label="select row"
        type="button"
      />

      <div className={cn.columnRowWrapper}>
        <div className={cn.columnRowLeft}>
          <div
            className={`${cn.columnRowTop} ${
              user.status === UserStatuses.DISABLED
                ? cn.columnRowTopArchived
                : ''
            }`}
          >
            <div className={cn.columnRowWrapperArchived}>
              <div className={cn.nameTitle}>{`${
                user.profile?.firstName || ''
              } ${user.profile?.lastName || ''}`}</div>
              {user.status === UserStatuses.DISABLED && (
                <div className={cn.archivedTitle}>Archived</div>
              )}
            </div>
            <div className={cn.roleTitle}>
              {user.employeeRoleTemplateName || '—'}
            </div>
          </div>

          <div className={cn.emailTitle}>{user.email}</div>
        </div>
        <button
          type="button"
          className={`button-white ${cn.buttonInfo} ${
            isSelectedRow ? cn.active : ''
          }`}
          onClick={() => {
            dispatch(onUserChange(user.id));
            navigate(generatePath(ROUTES.USER_EDIT, { userId: user.id }));
          }}
          aria-label="Info button"
        >
          <IconSettings width={20} height={20} />
        </button>
      </div>
    </div>
  );
};

export default ColumnRowUsers;
